const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'cf3e05e'

export default websiteVersion
